module.exports = __webpack_public_path__ + "static/media/video-slash.575baa81.svg";